module.exports = __webpack_public_path__ + "f4a8decef111b562883ba755fe0c6a26.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-aviators.png
// module id = 2328
// module chunks = 0